import * as React from "react";
import { useEffect, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { translate } from "../../translate/translate";
import { ErrorComponent } from "../error/error.component";

interface Element {
    [key: string]: any;
}

const AutocompleteSimple = (props: any) => {
    const {
        keepFilter,
        display,
        label,
        service,
        onSelectElement,
        element,
        required = false,
        disabled = false,
        clear = false,
        reset = false,
        filters = [],
        size = "medium",
    } = props;

    const [elements, setElements] = useState<Element[]>([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedOption, setSelectedOption] = useState<any>(null);
    const [initialValueSet, setInitialValueSet] = useState(false);
    const [focusAutocomplete, setFocusAutocomplete] = useState(false);
    const [internalReset, setInternalReset] = useState(false);

    useEffect(() => {
        if (keepFilter) {
            service.getById(keepFilter).then((response: any) => {
                setSelectedOption(response.data);
            });
        }
    }, []);


    useEffect(() => {
        if (element && !initialValueSet) {
            setSelectedOption(element);
            setInitialValueSet(true);
        }
    }, [element, initialValueSet]);

    useEffect(() => {
        fetchElements();
    }, [searchTerm]);

    useEffect(() => {
        if (clear) {
            setSelectedOption(null);
            setFocusAutocomplete(false);
        }
    }, [clear]);

    useEffect(() => {
        if (reset) {
            setInternalReset(true);
            setSelectedOption(null);
            setElements([]);
            setSearchTerm("");
            setInitialValueSet(false);
            setFocusAutocomplete(false);
            setTimeout(() => setInternalReset(false), 500);
        }
    }, [reset]);

    const fetchElements = () => {
        service.clearParameters();
        if (filters.length > 0) {
            filters.forEach((filter: any) => {
                const keys = Object.keys(filter);
                if (keys.length > 0) {
                    keys.forEach((key) => {
                        service.addParameter(key, filter[key]);
                    });
                }
            });
        }
        if (searchTerm) {
            service.addParameter("search", searchTerm);
        }
        service.getAll().then((response: any) => {
            setElements(response.data.results || response.data || []);
        }).catch((error: any) => {
            ErrorComponent(error);
        });
    };

    const handleAutocompleteChange = (event: React.ChangeEvent<any>, value: any | null) => {
        setSelectedOption(value);
        setSearchTerm("");
        onSelectElement(value);
    };

    const displayValue = (option: any) => {
        const displays = display instanceof Array ? display : [display];
        const values = displays.map((item) => option[item] ? translate.t(option[item].toString()) : "");
        return values.length > 1 ? values.join(" - ") : values[0];
    };

    return (
        <Autocomplete
            size={size}
            disabled={disabled}
            value={selectedOption}
            isOptionEqualToValue={(option, value) => {
                return option[display] === value[display];
            }}
            getOptionLabel={(option) => displayValue(option)}
            closeText={translate.t("close")}
            openText={translate.t("open")}
            clearText={translate.t("clear")}
            noOptionsText={translate.t("empty_listing")}
            options={elements}
            onChange={handleAutocompleteChange}
            onBlur={() => setFocusAutocomplete(true)}
            onInputChange={(event, newValue) => {
                if (selectedOption && !newValue.includes(selectedOption?.[display] ? selectedOption[display] : "")) {
                    setSelectedOption(null);
                }
                setSearchTerm(newValue);
            }}
            className={(focusAutocomplete && !selectedOption && required) ? "error-label-autocomplete" : ""}
            renderInput={(params) => (
                <TextField
                    {...params}
                    size={size}
                    sx={{
                        marginTop: 0,
                        marginBottom: "3px",
                    }}
                    margin="normal"
                    label={translate.t(label)}
                    required={required}
                    disabled={disabled}
                    InputProps={{
                        ...params.InputProps,
                        className: (focusAutocomplete && !selectedOption && required && !internalReset) ? "error-autocomplete" : "",
                    }}
                />
            )}
        />
    );
};

AutocompleteSimple.displayName = "AutocompleteSimple";
export default AutocompleteSimple;
